<template>
    <v-app id="app">
        <div v-show="!isLoading">
            <vDrawer v-if="$route.name !== 'login'" />
            <vView />
        </div>
        <div v-show="isLoading">
            <div class="fullview">
                <div class="loading-spacer"></div>
                <vue-loading
                    type="spin"
                    color="#333"
                    :size="{ width: '50px', height: '50px' }"
                ></vue-loading>
            </div>
        </div>
    </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { VueLoading } from 'vue-loading-template';
import vDrawer from './components/core/Drawer';
import vView from './components/core/View';

export default {
    name: 'App',
    components: {
        VueLoading,
        vDrawer,
        vView
    },
    computed: {
        ...mapState('loading', ['isLoading'])
    }
};
</script>

<style>
.fullview {
    width: 100%;
    height: 100%;
    background: #fefefe;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 205;
}
.loading-spacer {
    height: 30%;
}
</style>
